import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { spacing } from 'ui/theme';
import Dropdown from 'core/dropdown';

export const StyledCoreDropdown = styled(Dropdown)`
  &&&& {
    font-weight: bold; /** css file conversion */
    margin-bottom: -${pxToRem(1)};
  }
`;

export const ViewModePropertyContainer = styled.div`
  padding: ${spacing.half};
`;
